/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgParagraphSpacing02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 24 24"
    data-name="SvgParagraphSpacing02"
    {...props}
  >
    {props.children}
    <path
      stroke="#0d0d0d"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21 9.926h-8m8-3.951h-8m8 7.901h-8m8 3.951h-8m-7-7.506V4m3 3.358-3 2.963-3-2.963m3 6.32V20m-3-3.358 3-2.963 3 2.963"
    />
  </svg>
)
